var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status.isLoaded)?_c('LoadingState',{attrs:{"size":50}}):_c('CloudServerHistoryTable',{attrs:{"events":_vm.events,"status":_vm.status}})}
var staticRenderFns = []

export { render, staticRenderFns }